/*
  Перечень ключей обмена — §3.6.

  Отделён от блока выдачи не ради длины файла: выдача - это форма с состоянием и
  запросами, а здесь только показ того, что уже выдано.

  Отозванные ключи из перечня НЕ убираются, в отличие от списка ссылок должнику.
  Там оператору нужен ответ на вопрос «что сейчас открывает этот счёт», а здесь
  вопрос другой: «почему перестали приходить данные». Ответом чаще всего и будет
  отозванный ключ, которым обработка продолжает пользоваться.
*/

import { dateTime } from '../api/format.js'
import { Empty, Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'

/** Что сказать про обмен по этому ключу: работает, молчит или прекращён. */
function exchangeState(key) {
  if (!key.is_active) return { kind: 'muted', title: 'отозван' }
  if (key.used_count === 0) return { kind: 'warn', title: 'ещё не пользовались' }
  return { kind: 'calm', title: 'обмен идёт' }
}

export default function ConnectorKeyList({ keys, bar, onRevoke, busy }) {
  // 21.10.2026: ключей у заказчика со временем набирается много (каждая выдача и отзыв
  // оставляют строку), поэтому страницы режет сервер, а под перечнем - общая панель с
  // числом записей. `keys` - строки текущей страницы, `bar` - свойства панели от родителя.
  if (keys.length === 0) {
    return (
      <Empty title="Ключей обмена нет">
        Здесь появятся выданные ключи: чем помечен, когда выдан и когда им пользовались в последний
        раз. Пока ключа нет, обмен с 1С не идёт, и сведения о должниках приходится грузить файлом.
      </Empty>
    )
  }

  return (
    <>
      <div className="table-scroll">
        <table className="table">
          <thead>
            <tr>
              <th>Пометка</th>
              <th>Выдан</th>
              <th>Последний обмен</th>
              <th>Состояние</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {keys.map((key) => {
              const state = exchangeState(key)
              return (
                <tr key={key.key_id}>
                  <td>{key.note || 'без пометки'}</td>
                  <td data-label="Выдан">{dateTime(key.issued_at)}</td>
                  <td data-label="Последний обмен">
                    {key.last_used_at ? dateTime(key.last_used_at) : 'ещё не было'}
                    <div className="muted">
                      {key.used_count === 0
                        ? 'обработка 1С ни разу не присылала данные'
                        : `обменов: ${key.used_count}`}
                    </div>
                  </td>
                  <td data-label="Состояние">
                    <Tag kind={state.kind}>{state.title}</Tag>
                    {key.revoked_at ? (
                      <div className="muted">{dateTime(key.revoked_at)}</div>
                    ) : null}
                  </td>
                  <td>
                    {key.is_active ? (
                      <button
                        className="button button--quiet"
                        type="button"
                        disabled={busy}
                        onClick={() => onRevoke(key)}
                      >
                        Отозвать
                      </button>
                    ) : null}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      <PageBar {...bar} what="ключей" />
    </>
  )
}
